<template>
	<div id="login1">
		<div class="loginConbox1">
			<div class="header"></div>
			<div class="loginBox1">
				<div class="loginCon1">
					<el-card shadow="always" class="login_input" v-if="smdl">
						<div slot="header" class="clearfix formTitlt" style="padding: 10px;">
							<span class=""
								style="display: block; font-size: 18px; color: #003894; margin-left:-15px;">{{
									$t('home.text_') }}
							</span>
						</div>
						<el-form :model="loginForm" status-icon class="demo-ruleForm" :rules="rules" ref="loginForm">
							<el-form-item prop="username">
								<el-input type="text" v-model="loginForm.username" auto-complete="off"
									:placeholder="$t('home.text1')" prefix-icon="el-icon-user" clearable></el-input>
							</el-form-item>
							<el-form-item prop="password">
								<el-input type="password" v-model="loginForm.password" auto-complete="off"
									:placeholder="$t('home.text2')" prefix-icon="el-icon-unlock"
									show-password></el-input>
							</el-form-item>
							<el-form-item>
								<el-button class="subBtn" type="primary" @click="submitForm">{{ $t('home.text3')
								}}</el-button>
							</el-form-item>
							<el-dropdown class='international' @command="handleSetLanguage">
								<div>
									<span class="el-dropdown-link"><i class="fa fa-language fa-lg"></i> &nbsp; language:
										&nbsp;{{ language }} <i class="el-icon-arrow-down el-icon--right"></i>
									</span>
								</div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="cn">中文</el-dropdown-item>
									<el-dropdown-item command="en">English</el-dropdown-item>
									<el-dropdown-item command="es">España</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</el-form>
					</el-card>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	inject: ['reload'],
	data() {
		return {

			ruleForm: {
				id: "",
				huijuCloudAPIUrl: "",
				huijuCloudAPIUrl_enable: 1,
				huijuCloudMM: ""
			},
			type_options: [{
				value: 0,
				label: "是"
			},
			{
				value: 1,
				label: "否"
			}
			],
			lg: '',
			lg_options: [{
				value: 0,
				label: "中文"
			},
			{
				value: 1,
				label: "英文"
			},
			{
				value: 1,
				label: "西班牙"
			}
			],
			configForm: false, //编辑表单
			smdl: true,
			loginForm: {
				username: "",
				password: ""

			},

			language: '',

			rules: {
				username: [{
					required: true,
					message: this.$t('btn.text4'),
					trigger: "blur"
				}],
				password: [{
					required: true,
					message: this.$t('btn.text5'),
					trigger: "blur"
				}]
			}
		};
	},
	created() {
		//    一定要在create里面执行一下写的回车事件enterSearch(),否则会执行不了
		this.enterSearch()

	},
	methods: {

		handleSetLanguage(lang) {

			this.$i18n.locale = lang
			localStorage.setItem('lang', lang)
			this.getLanguage(lang)
			// window.location.reload();
		},
		getLanguage(val) {
			if (val === 'cn') {
				this.language = '中文'

			}
			if (val === 'en') {
				this.language = 'English'
			}
			if (val === 'es') {
				this.language = 'España'

			}

		},
		witsoon() {
			window.open("http://witsoon.com", '_blank')
		},


		enterSearch() {
			document.onkeydown = e => {
				//13表示回车键，baseURI是当前页面的地址，为了更严谨，也可以加别的，可以打印e看一下
				if (e.keyCode === 13) {
					//回车后执行搜索方法
					this.submitForm()

				}
			}
		},
		querygetSoftVersion() {
			let storage = window.sessionStorage;

			this.$axios({
				url: "/api/getSoftVersion",
				method: "get",
				params: {}
			})
				.then(res => {
					var versionType = res.data.versionType;
					storage.setItem("versionType", versionType);
				})
				.catch(err => {
					console.log(err);
				});
		},
		submitForm() {
			var that = this;
			console.log("登录");
			this.$axios({
				url: "/api/login",
				method: "post",
				data: {
					account: that.loginForm.username,
					password: that.loginForm.password,
					userType: "CLIENT"
				},
				headers: {
					"authorization": "",
					"Content-Type": "application/json; charset=utf-8"
				}
			})
				.then(res => {
					console.log(res.data)
					let msg = res.data.msg
					let result = res.data.token;
					let data = res.data.user;

					if (msg !== "") {
						this.$message({
							showClose: true,
							message: res.data.msg,
							type: "error",
							duration: 3000
						});
						return;
					}
					let type = ""
					let role = ""
					let name = ""
					if (res.data.user.role !== null) {
						type = res.data.user.role.type;
						role = res.data.user.role.authority;
						name = res.data.user.role.name;
					}
					let company = data.scenicArea;
					let zone = data.zone;
					let options=data.options;
					let openOnlineRefund=0;
					let capacityLimit=0;
					if(options!="" && options!=undefined){
						openOnlineRefund=JSON.parse(options).openOnlineRefund;
						capacityLimit=JSON.parse(options).capacityLimit;
					}
					let roles;
					if (role == null) {
						roles = {
							ticketSetting: {
								ticketSetting: 1,
								tickesSpot: 1,
								ticketScenicname: 1,
								ticketChecking: 1,
								ticketGate: 1,
								ticketEquipment: 0
							},
							ticketManagement: {
								ticketManagement: 1,
								ticketMaking: 1,
								ticketCard: 1,
								ticketStorage: 1,
								ticketAuthentication: 1,
								ticketMerchandise: 0,
								ticketMerchandisekind: 0,
								ticketPreferential: 1,
								ticketCompensationPrice: 1,
								ticketBilling: 1,
								ticketTime: 1,
								ticketGroup: 1,
								ticketCalendar: 0,
								print: 1,
								ticketControl: 1,
								ticketTimeSharing: 1,
								ticketMatchingRules: 1,
							},
							setting: {
								setting: 1,
								unitsetting: 1,
								permissionsetting: 1,
								usersetting: 1,

							},
							goods: {
								goods: 1,
								shops: 1,
								gatalogue: 1,
								commodity: 1,
								goodsloading: 1,
								Inventory: 1,
								Commoditysales: 1,
								Salesdetails: 1,
							},

							ticketVenue: {
								ticketVenue: 0,
								ticketVenuesetup: 0,
								ticketVenueplan: 0
							},


							Warehouse: {
								Warehouse: 1,
								Entry: 1,
								Ticket_Inventory: 1,
							},

							ticketCollection: {
								ticketCollection: 1,
								ticketWarehouseManagement: 1,
								ticketCollectionManagement: 1,
								returnManagement: 1,
								dataStatistics: 1
							},
							Stockholder: {
								Stockholder: 1,
								Shareholder: 1,
								Share: 1,
								Statement: 1,
							},
							passenger: {
								passenger: 1,
								camera: 1,
								statistics: 1,

							},
							ticketReport: {
								ticketReport: 1,
								ticketrOrder: 1,
								ticketTicket: 1,
								ticketCode: 1,
								ticketImport: 1,
								ticketConsume: 1,
								ticketActivate: 1,
								ticketConsumestate: 1,
								Supplementary: 1,
								ticketInventory: 0,
								ticketMerchandiseReport: 0,
								ticketMerchandiseSale: 0,
								ticketFlow: 1,
								ticketRefund: 1,
								ticketStorageReport: 0,
								statisticAnalysis: 1
							},

							ticketInput: {
								ticketInput: 0,
								ticketType: 0,
								ticketCommodity: 0,
							},
							ticketsystem: {
								ticketsystem: 1,
								ticketWechat: 1,
								ticketAlipay: 1,
								ticketDatabase: 0,
								ticketInformation: 1,
								EquipmentUpgrade: 1,
								ticketLog: 1,
							},

							ticketStatements: {
								ticketStatements: 1
							},

							datalist: {
								datalist: 1
							},

							release: {
								release: 1,
								programRelease: 1,
								graphicRelease: 1,
								contentRelease: 0,
								dataRelease: 1,
							},

							travelAgencyManagement: {
								travelAgencyManagement: 1,
								travelAgencyManagement1: 1,
								ticketTypeManagement: 1,
								orderManagement: 1,
								rechargeManagement: 1,
								userManagement: 1,
								financialStatements: 1,
								test: 1,
							},

							sellPrintTickets: {
								sellPrintTickets: 0,
							},
							sellPrintTicketsgoods: {
								sellPrintTicketsgoods: 0,
							},
							sellScanningTicketing: {
								sellScanningTicketing: 0,
							},
							sellMembershipCard: {
								sellMembershipCard: 0,
							},
							sellMembershipCard: {
								sellMembershipCard: 0,
							},
							sellMemberrenewal: {
								sellMemberrenewal: 0,
							},
							sellStoredCard: {
								sellStoredCard: 0,
							},
							sellRefund: {
								sellRefund: 0,
							},
							sellCollection: {
								sellCollection: 0,
							},
							sellRecord: {
								sellRecord: 0,
							},
							travelAgencyOrderManagement: {
								travelAgencyOrderManagement: 0,
							},
							sellQuery: {
								sellQuery: 0,
							},
							sellDifference: {
								sellDifference: 0,
							},
							sellgoods: {
								sellgoods: 0,
							},
							annualCardActivation: {
								annualCardActivation: 0,
							},
							scan: {
								scan: 0,
							},
							ticketDetailsRecord: {
								ticketDetailsRecord: 1
							},
							travelAgencyMenu: {
								travelAgencyMenu: 0,
								importOrder: 0,
								travelAgencyOrderManagement: 0,
								travelAgencyRechargeManagement: 0
							}

						}
					} else if (res.data.user.useType == 10) {
						roles = {
							ticketSetting: {
								ticketSetting: 0,
								tickesSpot: 0,
								ticketScenicname: 0,
								ticketChecking: 0,
								ticketGate: 0,
								ticketEquipment: 0
							},
							ticketManagement: {
								ticketManagement: 0,
								ticketMaking: 0,
								ticketCard: 0,
								ticketStorage: 0,
								ticketAuthentication: 0,
								ticketMerchandise: 0,
								ticketMerchandisekind: 0,
								ticketPreferential: 0,
								ticketCompensationPrice: 0,
								ticketBilling: 0,
								ticketTime: 0,
								ticketGroup: 0,
								ticketCalendar: 0,
								print: 0,
								ticketControl: 0,
								ticketTimeSharing: 0,
								ticketMatchingRules: 0,
							},
							setting: {
								setting: 0,
								unitsetting: 0,
								permissionsetting: 0,
								usersetting: 0,

							},
							goods: {
								goods: 0,
								shops: 0,
								gatalogue: 0,
								commodity: 0,
								goodsloading: 0,
								Inventory: 0,
								Commoditysales: 0,
								Salesdetails: 0,
							},

							ticketVenue: {
								ticketVenue: 0,
								ticketVenuesetup: 0,
								ticketVenueplan: 0
							},


							Warehouse: {
								Warehouse: 0,
								Entry: 0,
								Ticket_Inventory: 0,
							},

							ticketCollection: {
								ticketCollection: 0,
								ticketWarehouseManagement: 0,
								ticketCollectionManagement: 0,
								returnManagement: 0,
								dataStatistics: 0
							},
							Stockholder: {
								Stockholder: 0,
								Shareholder: 0,
								Share: 0,
								Statement: 0,
							},
							passenger: {
								passenger: 0,
								camera: 0,
								statistics: 0,

							},
							ticketReport: {
								ticketReport: 0,
								ticketrOrder: 0,
								ticketTicket: 0,
								ticketCode: 0,
								ticketImport: 0,
								ticketConsume: 0,
								ticketActivate: 0,
								ticketConsumestate: 0,
								Supplementary: 0,
								ticketInventory: 0,
								ticketMerchandiseReport: 0,
								ticketMerchandiseSale: 0,
								ticketFlow: 0,
								ticketRefund: 0,
								ticketStorageReport: 0,
								statisticAnalysis: 0
							},

							ticketInput: {
								ticketInput: 0,
								ticketType: 0,
								ticketCommodity: 0,
							},
							ticketsystem: {
								ticketsystem: 0,
								ticketWechat: 0,
								ticketAlipay: 0,
								ticketDatabase: 0,
								ticketInformation: 0,
								EquipmentUpgrade: 0,
								ticketLog: 0,
							},

							ticketStatements: {
								ticketStatements: 0
							},

							datalist: {
								datalist: 0
							},

							release: {
								release: 0,
								programRelease: 0,
								graphicRelease: 0,
								contentRelease: 0,
								dataRelease: 0,
							},

							travelAgencyManagement: {
								travelAgencyManagement: 0,
								travelAgencyManagement1: 0,
								ticketTypeManagement: 0,
								orderManagement: 0,
								rechargeManagement: 0,
								userManagement: 0,
								financialStatements: 0,
								test: 0,
							},

							sellPrintTickets: {
								sellPrintTickets: 0,
							},
							sellPrintTicketsgoods: {
								sellPrintTicketsgoods: 0,
							},
							sellScanningTicketing: {
								sellScanningTicketing: 0,
							},
							sellMembershipCard: {
								sellMembershipCard: 0,
							},
							sellMembershipCard: {
								sellMembershipCard: 0,
							},
							sellMemberrenewal: {
								sellMemberrenewal: 0,
							},
							sellStoredCard: {
								sellStoredCard: 0,
							},
							sellRefund: {
								sellRefund: 0,
							},
							sellCollection: {
								sellCollection: 0,
							},
							sellRecord: {
								sellRecord: 0,
							},
							travelAgencyOrderManagement: {
								travelAgencyOrderManagement: 0,
							},
							sellQuery: {
								sellQuery: 0,
							},
							sellDifference: {
								sellDifference: 0,
							},
							sellgoods: {
								sellgoods: 0,
							},
							annualCardActivation: {
								annualCardActivation: 0,
							},
							scan: {
								scan: 0,
							},
							ticketDetailsRecord: {
								ticketDetailsRecord: 0
							},
							travelAgencyMenu: {
								travelAgencyMenu: 1,
								importOrder: 1,
								travelAgencyOrderManagement: 1,
								travelAgencyRechargeManagement: 1
							}

						}
					} else {
						roles = JSON.parse(role)
						roles.ticketDetailsRecord = {
							ticketDetailsRecord: 1
						};
						console.log(roles)
					}
					let ticketSetting1 = roles.ticketSetting.ticketSetting;
					let ticketSetting2 = roles.ticketSetting.tickesSpot;
					let ticketSetting3 = roles.ticketSetting.ticketScenicname;
					let ticketSetting4 = roles.ticketSetting.ticketChecking;
					let ticketSetting5 = roles.ticketSetting.ticketGate;
					let ticketSetting6 = roles.ticketSetting.ticketEquipment;
					let ticketManagement1 = roles.ticketManagement.ticketManagement;
					let ticketManagement2 = roles.ticketManagement.ticketMaking;
					let ticketManagement3 = roles.ticketManagement.ticketCard;
					let ticketManagement4 = roles.ticketManagement.ticketStorage;
					let ticketManagement5 = roles.ticketManagement.ticketAuthentication;
					let ticketManagement6 = roles.ticketManagement.ticketMerchandise;
					let ticketManagement7 = roles.ticketManagement.ticketMerchandisekind;
					let ticketManagement8 = roles.ticketManagement.ticketPreferential;
					let ticketManagement9 = roles.ticketManagement.ticketCompensationPrice;
					let ticketManagement10 = roles.ticketManagement.ticketBilling;
					let ticketManagement11 = roles.ticketManagement.ticketTime;
					let ticketManagement13 = roles.ticketManagement.ticketGroup;
					let ticketManagement12 = roles.ticketManagement.ticketCalendar;
					let ticketManagement14 = roles.ticketManagement.ticketControl;
					let ticketManagement15 = roles.ticketManagement.ticketTimeSharing;
					let ticketManagement16 = roles.ticketManagement.ticketMatchingRules;


					let setting5 = roles.ticketManagement.print;
					let ticketVenue1 = roles.ticketVenue.ticketVenue;
					let ticketVenue2 = roles.ticketVenue.ticketVenuesetup;
					let ticketVenue3 = roles.ticketVenue.ticketVenueplan;
					let ticketReport1 = roles.ticketReport.ticketReport;
					let ticketReport2 = roles.ticketReport.ticketrOrder;
					let ticketReport3 = roles.ticketReport.ticketTicket;
					let ticketReport4 = roles.ticketReport.ticketCode;
					let ticketReport5 = roles.ticketReport.ticketImport;
					let ticketReport6 = roles.ticketReport.ticketConsume;
					let ticketReport7 = roles.ticketReport.ticketConsumestate;
					let ticketReport8 = roles.ticketReport.ticketInventory;

					let ticketReport9 = roles.ticketReport.ticketMerchandiseReport;
					let ticketReport10 = roles.ticketReport.ticketMerchandiseSale;
					let ticketReport11 = roles.ticketReport.ticketFlow;
					let ticketReport12 = roles.ticketReport.ticketStorageReport;
					let ticketReport13 = roles.ticketReport.Supplementary;
					let ticketReport14 = roles.ticketReport.ticketRefund;
					let ticketReport15 = roles.ticketReport.statisticAnalysis;
					let ticketReport16 = roles.ticketReport.ticketActivate;

					let ticketInput1 = roles.ticketInput.ticketInput;
					let ticketInput3 = roles.ticketInput.ticketCommodity;
					let ticketInput2 = roles.ticketInput.ticketType;

					let ticketsystem1 = roles.ticketsystem.ticketsystem;
					let ticketsystem2 = roles.ticketsystem.ticketWechat;
					let ticketsystem3 = roles.ticketsystem.ticketAlipay;
					let ticketsystem4 = roles.ticketsystem.ticketDatabase;
					let ticketsystem5 = roles.ticketsystem.ticketInformation;
					let ticketsystem6 = roles.ticketsystem.ticketLog;
					let ticketsystem7 = roles.ticketsystem.EquipmentUpgrade;

					let ticketrelease1 = roles.release.release;
					let ticketrelease2 = roles.release.programRelease;
					let ticketrelease3 = roles.release.graphicRelease;
					let ticketrelease4 = roles.release.contentRelease;
					let ticketrelease5 = roles.release.dataRelease;

					let travelAgencyManagement1 = roles.travelAgencyManagement.travelAgencyManagement;
					let travelAgencyManagement2 = roles.travelAgencyManagement.travelAgencyManagement1;
					let travelAgencyManagement3 = roles.travelAgencyManagement.ticketTypeManagement;
					let travelAgencyManagement4 = roles.travelAgencyManagement.orderManagement;
					let travelAgencyManagement5 = roles.travelAgencyManagement.rechargeManagement;
					let travelAgencyManagement6 = roles.travelAgencyManagement.userManagement;
					let travelAgencyManagement7 = roles.travelAgencyManagement.financialStatements;
					let travelAgencyManagement8 = roles.travelAgencyManagement.test;

					let passenger1 = roles.passenger.passenger;
					let passenger2 = roles.passenger.camera;
					let passenger3 = roles.passenger.statistics;

					let goods1 = roles.goods.goods;
					let goods2 = roles.goods.shops;
					let goods3 = roles.goods.gatalogue;
					let goods4 = roles.goods.commodity;
					let goods5 = roles.goods.goodsloading;
					let goods6 = roles.goods.Inventory;
					let goods7 = roles.goods.Commoditysales;
					let goods8 = roles.goods.Salesdetails;


					let Warehouse1 = roles.Warehouse.Warehouse;
					let Warehouse2 = roles.Warehouse.Entry;
					let Warehouse3 = roles.Warehouse.Ticket_Inventory;

					let ticketCollection1 = roles.ticketCollection.ticketCollection;
					let ticketCollection2 = roles.ticketCollection.ticketWarehouseManagement;
					let ticketCollection3 = roles.ticketCollection.ticketCollectionManagement;
					let ticketCollection4 = roles.ticketCollection.returnManagement;
					let ticketCollection5 = roles.ticketCollection.dataStatistics;

					let Stockholder1 = roles.Stockholder.Stockholder;
					let Stockholder2 = roles.Stockholder.Shareholder;
					let Stockholder3 = roles.Stockholder.Share;
					let Stockholder4 = roles.Stockholder.Statement;

					let ticketStatements1 = roles.ticketStatements.ticketStatements;
					let datalist1 = roles.datalist.datalist;
					let sellticket1 = roles.sellPrintTickets.sellPrintTickets //打印售票
					let sellticket13 = roles.sellPrintTicketsgoods.sellPrintTicketsgoods //打印售票
					let sellticket2 = roles.sellScanningTicketing.sellScanningTicketing //扫描售票
					let sellticket3 = roles.sellMembershipCard.sellMembershipCard //会员卡
					let sellticket4 = roles.sellStoredCard.sellStoredCard //储值卡
					let sellticket5 = roles.sellRefund.sellRefund //退票
					let sellticket6 = roles.sellCollection.sellCollection //取票
					let sellticket7 = roles.sellRecord.sellRecord //当班记录
					let sellticket8 = roles.sellQuery.sellQuery //门票查询
					let sellticket9 = roles.sellMemberrenewal.sellMemberrenewal //门票续费
					let sellticket10 = roles.sellDifference.sellDifference //门票补差价
					let sellticket11 = roles.sellgoods.sellgoods //商品
					let sellticket15 = roles.annualCardActivation.annualCardActivation //商品
					let sellticket12 = roles.scan.scan //扫描售票
					let sellticket14 = roles.ticketDetailsRecord.ticketDetailsRecord
					let sellticket16 = roles.travelAgencyOrderManagement.travelAgencyOrderManagement

					let setting1 = roles.setting.setting; //权限公用
					let setting2 = roles.setting.unitsetting;
					let setting3 = roles.setting.permissionsetting;
					let setting4 = roles.setting.usersetting;

					let travelAgencyMenu1 = roles.travelAgencyMenu.travelAgencyMenu;
					let travelAgencyMenu2 = roles.travelAgencyMenu.importOrder;
					let travelAgencyMenu3 = roles.travelAgencyMenu.travelAgencyOrderManagement;
					let travelAgencyMenu4 = roles.travelAgencyMenu.travelAgencyRechargeManagement;


					let companyId; //景区
					if (company == null) {
						companyId = '';
					} else {
						companyId = data.scenicArea.id;
					}
					let zoneID; //景点
					if (zone == null) {
						zoneID = '';
					} else {
						zoneID = data.zone.id;
					}

					let category = "";
					if (res.data.user.role !== null) {
						category = res.data.user.role.category;
					}
					if (category == null) {
						category = '0';
					}
					if (data !== null) {
						this.$message({
							showClose: true,
							message: "success,登录成功，正在加载.....",
							type: "success",
							duration: 3000
						})
						let storage = window.sessionStorage;
						/*票务基础设置*/
						storage.setItem("ticketSetting1", ticketSetting1);
						storage.setItem("ticketSetting2", ticketSetting2);
						storage.setItem("ticketSetting6", ticketSetting6);
						storage.setItem("ticketSetting3", ticketSetting3);
						storage.setItem("ticketSetting4", ticketSetting4);
						storage.setItem("ticketSetting5", ticketSetting5);
						/*业务管理*/
						storage.setItem("ticketManagement1", ticketManagement1);
						storage.setItem("ticketManagement2", ticketManagement2);
						storage.setItem("ticketManagement3", ticketManagement3);
						storage.setItem("ticketManagement4", ticketManagement4);
						storage.setItem("ticketManagement5", ticketManagement5);
						storage.setItem("ticketManagement6", ticketManagement6);
						storage.setItem("ticketManagement7", ticketManagement7);
						storage.setItem("ticketManagement8", ticketManagement8);
						storage.setItem("ticketManagement9", ticketManagement9);
						storage.setItem("ticketManagement10", ticketManagement10);
						storage.setItem("ticketManagement13", ticketManagement13);
						storage.setItem("ticketManagement11", ticketManagement11);
						storage.setItem("ticketManagement12", ticketManagement12);
						storage.setItem("ticketManagement14", ticketManagement14);
						storage.setItem("ticketManagement15", ticketManagement15);
						storage.setItem("ticketManagement16", ticketManagement16);

						/*票务场馆设置*/
						storage.setItem("ticketVenue1", ticketVenue1);
						storage.setItem("ticketVenue2", ticketVenue2);
						storage.setItem("ticketVenue3", ticketVenue3);
						/*商品管理*/
						storage.setItem("goods1", goods1);
						storage.setItem("goods2", goods2);
						storage.setItem("goods3", goods3);
						storage.setItem("goods4", goods4);
						storage.setItem("goods5", goods5);
						storage.setItem("goods6", goods6);
						storage.setItem("goods7", goods7);
						storage.setItem("goods8", goods8);
						/*查询报表*/
						storage.setItem("ticketReport1", ticketReport1);
						storage.setItem("ticketReport2", ticketReport2);
						storage.setItem("ticketReport3", ticketReport3);
						storage.setItem("ticketReport4", ticketReport4);
						storage.setItem("ticketReport5", ticketReport5);
						storage.setItem("ticketReport6", ticketReport6);
						storage.setItem("ticketReport7", ticketReport7);
						storage.setItem("ticketReport8", ticketReport8);
						storage.setItem("ticketReport9", ticketReport9);
						storage.setItem("ticketReport10", ticketReport10);
						storage.setItem("ticketReport11", ticketReport11);
						storage.setItem("ticketReport12", ticketReport12);
						storage.setItem("ticketReport13", ticketReport13);
						storage.setItem("ticketReport14", ticketReport14);
						storage.setItem("ticketReport15", ticketReport15);
						storage.setItem("ticketReport16", ticketReport16);

						storage.setItem("ticketStatements1", ticketStatements1);
						storage.setItem("datalist1", datalist1);


						/*库存管理*/
						storage.setItem("ticketInput1", ticketInput1);
						storage.setItem("ticketInput2", ticketInput2);
						storage.setItem("ticketInput3", ticketInput3);
						/*系统设置*/
						storage.setItem("ticketsystem1", ticketsystem1);
						storage.setItem("ticketsystem2", ticketsystem2);
						storage.setItem("ticketsystem3", ticketsystem3);
						storage.setItem("ticketsystem4", ticketsystem4);
						storage.setItem("ticketsystem5", ticketsystem5);
						storage.setItem("ticketsystem6", ticketsystem6);
						storage.setItem("ticketsystem7", ticketsystem7);

						/*票库存管理 */


						storage.setItem("Warehouse1", Warehouse1);
						storage.setItem("Warehouse2", Warehouse2);
						storage.setItem("Warehouse3", Warehouse3);

						/*领票管理*/
						storage.setItem("ticketCollection1", ticketCollection1);
						storage.setItem("ticketCollection2", ticketCollection2);
						storage.setItem("ticketCollection3", ticketCollection3);
						storage.setItem("ticketCollection4", ticketCollection4);
						storage.setItem("ticketCollection5", ticketCollection5);

						/* 股东管理*/

						storage.setItem("Stockholder1", Stockholder1);
						storage.setItem("Stockholder2", Stockholder2);
						storage.setItem("Stockholder3", Stockholder3);
						storage.setItem("Stockholder4", Stockholder4);

						/* 信息发布*/
						storage.setItem("ticketrelease1", ticketrelease1);
						storage.setItem("ticketrelease2", ticketrelease2);
						storage.setItem("ticketrelease3", ticketrelease3);
						storage.setItem("ticketrelease4", ticketrelease4);
						storage.setItem("ticketrelease5", ticketrelease5);


						/* 旅行社管理*/
						storage.setItem("travelAgencyManagement1", travelAgencyManagement1);
						storage.setItem("travelAgencyManagement2", travelAgencyManagement2);
						storage.setItem("travelAgencyManagement3", travelAgencyManagement3);
						storage.setItem("travelAgencyManagement4", travelAgencyManagement4);
						storage.setItem("travelAgencyManagement5", travelAgencyManagement5);
						storage.setItem("travelAgencyManagement6", travelAgencyManagement6);
						storage.setItem("travelAgencyManagement7", travelAgencyManagement7);
						storage.setItem("travelAgencyManagement8", travelAgencyManagement8);


						/* 客流分析*/
						storage.setItem("passenger1", passenger1);
						storage.setItem("passenger2", passenger2);
						storage.setItem("passenger3", passenger3);
						/*打印售票*/
						storage.setItem("sellticket1", sellticket1);
						storage.setItem("sellticket2", sellticket2);
						storage.setItem("sellticket3", sellticket3);

						storage.setItem("sellticket4", sellticket4);
						storage.setItem("sellticket5", sellticket5);
						storage.setItem("sellticket6", sellticket6);

						storage.setItem("sellticket7", sellticket7);
						storage.setItem("sellticket9", sellticket9);
						storage.setItem("sellticket8", sellticket8);
						storage.setItem("sellticket10", sellticket10);
						storage.setItem("sellticket11", sellticket11);
						storage.setItem("sellticket12", sellticket12);
						storage.setItem("sellticket13", sellticket13);
						storage.setItem("sellticket14", sellticket14);
						storage.setItem("sellticket15", sellticket15);
						storage.setItem("sellticket16", sellticket16);

						storage.setItem("travelAgencyMenu1", travelAgencyMenu1)
						storage.setItem("travelAgencyMenu2", travelAgencyMenu2)
						storage.setItem("travelAgencyMenu3", travelAgencyMenu3)
						storage.setItem("travelAgencyMenu4", travelAgencyMenu4)

						storage.setItem("setting1", setting1);
						storage.setItem("setting2", setting2);
						storage.setItem("setting3", setting3);
						storage.setItem("setting4", setting4);
						storage.setItem("setting5", setting5);

						storage.setItem("companyId", companyId); // 景区
						storage.setItem("zone", zoneID); // 景点
						storage.setItem("userName", data.account); // 用户名
						storage.setItem("token", result); // 保存用户登录信息
						storage.setItem("userId", data.id) // 保存用户登录信息
						storage.setItem("useType", data.useType) // 保存用户登录信息
						storage.setItem("openOnlineRefund", openOnlineRefund) // 线上退票权限
						storage.setItem("capacityLimit", capacityLimit) // 设置旅行社人数限制权限
						if (res.data.user.role !== null) {
							storage.setItem("name", data.role.name); // 权限名
						}
						storage.setItem("category", category); // 权限名
						/*  storage.setItem("companyId",'123123');// 景区
						storage.setItem("zone",'1');// 景点
						storage.setItem("userName",'');// 用户名
						storage.setItem("token","222");// 保存用户登录信息
						storage.setItem("userId","1")// 保存用户登录信息
						storage.setItem("name","222");// 权限名
						storage.setItem("category","1");// 权限名
								*/
						if (data.travelAgency) {
							storage.setItem("travelAgency", JSON.stringify(data.travelAgency));
						}
						this.$router.push({
							path: "/index"
						});

						window.location.reload();
						// loading.close()
						//关闭 Loading 加载吗
					} else {
						this.$message({
							showClose: true,
							message: "error,res.data.msg",
							type: "error",
							duration: 3000
						});
					}

				})

				.catch(err => {
					this.$message({
						showClose: true,
						message: "error,登录失败，服务未连接：" + err,
						type: "error",
						duration: 3000
					});

				});
		},

		messagea() {
			this.$axios({
				url: "/api/sysConfig",
				method: "get",
				data: {},
				headers: {
					"Content-Type": "application/json; charset=utf-8"
				}
			})
				.then(res => {
					this.ruleForm.id = res.data[0][0].id;
					this.ruleForm.huijuCloudAPIUrl = res.data[0][0].huijuCloudAPIUrl;
					this.ruleForm.huijuCloudAPIUrl_enable = res.data[0][0].huijuCloudAPIUrl_enable;
					this.ruleForm.huijuCloudMM = '';
				})
				.catch(err => {
					console.log(err);
					this.$message({
						showClose: true,
						message: "error,获取信息失败",
						type: "error",
						duration: 5000
					});
				});
		}

	},
	mounted() {
		this.querygetSoftVersion();
	}
};
</script>
<style scoped>
#config {
	width: 100%;
	height: 60px;
	position: fixed;
	bottom: 10px;
	background-color: #2d3a4b;

}

#login1 {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: #2d3a4b;
	background-size: cover;
}

#login1 .loginConbox1 {
	background: #2d3a4b;
}

#login1 .header {
	height: 60px;
	position: relative;
	background: #2d3a4b;
	min-width: 0px !important;
}

.iconcolor {
	color: #409eff;
}

#login1 .loginBox1 {
	width: 400px;
	height: 450px;
	z-index: 10;
	text-align: left;
	position: fixed;
	left: 50%;
	margin-left: -200px;
	top: 50%;
	margin-top: -225px;
}

#login1 .loginCon1 {
	width: 100%;
	height: 400px;
	border-radius: 5px;
}

#login1 .login_input {
	margin-top: 22px;
	border-radius: 2px;
}

.demo-ruleForm {
	text-align: left;
}

.title_ {
	font-size: 32px;
	font-weight: 500;
	color: #ffffff;
	width: 449.5px;
	margin-bottom: 30px;
}

.clearfix {
	height: 20px;
	margin-bottom: 5px;

}

.subBtn {
	width: 100%;
}

.el-card__body {
	padding: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/system/index/login/index.vue